<template>
  <div class="pt-5" style="max-width: 400px;">
    <vue-headful title="Meine Daten" description="Aimz"/>
    <v-form>
      <v-row>
        <v-col>
          <header1 class="mt-5">Über Dich</header1>
          <div class="ml-5 mr-5 mt-5">
            <v-text-field v-model="user_data.username" label="Benutzername"></v-text-field>
<!--            <p class="body-2">Deine persönlichen Daten sind sensibel. Deshalb legen wir-->
<!--              größten Wert auf verantwortlichen Umgang mit deinen Daten, welche nur-->
<!--              anonymisiert verarbeitet werden.-->
<!--            </p>-->
            <v-select v-model="user_data.sex" :items="sex_options" label="Geschlecht">
            </v-select>
            <v-select v-model="user_data.birthyear" :items="year_options" label="Geburtsjahr">
            </v-select>
            <v-select v-model="user_data.country" :items="country_options" label="Land">
            </v-select>
            <v-text-field v-if="user_data.country==='Anderes Land'" v-model="user_data.which_country"
                          label="Welches Land?"></v-text-field>
            <v-text-field v-model="user_data.zip" label="PLZ"></v-text-field>
          </div>


          <header1 class="mt-5">Familie</header1>
          <div class="ml-5 mr-5 mt-5">
            <v-select v-model="user_data.family" :items="family_options" label="Familienstand">
            </v-select>

            <!--            kids-->
            <v-row>
              <v-col :cols="3">
                <span class="body-2 font-weight-light mr-1">Kinder</span><br>
                <span
                    class="display-3 font-weight-light"
                    v-text="user_data.num_kids"
                ></span>
              </v-col>
              <v-col :cols="9" class="pl-0 mt-9">
                <v-slider
                    class="my-auto"
                    v-model="nkids"
                    color="gelb"
                    track-color="grey"
                    always-dirty
                    min="0"
                    max="10"
                >
                  <template v-slot:prepend>
                    <v-icon @click="nkids--">
                      mdi-minus
                    </v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon @click="nkids++">
                      mdi-plus
                    </v-icon>
                  </template>
                </v-slider>
              </v-col>
            </v-row>
            <template>
              <v-text-field v-for="i in nkids" v-model="kids['kid'+(i-1)]" :label="'Kind '+i+' Geburtsjahr'" :key="i"
                            type="number">
              </v-text-field>
            </template>
          </div>


          <header1 class="mt-5">Arbeit</header1>
          <div class="ml-5 mr-5 mt-5">
            <v-select v-model="user_data.job" :items="job_options" label="Job">
            </v-select>
            <v-text-field v-model="user_data.workhours" label="Wochenstunden, ca."
                          type="number">
            </v-text-field>
            <v-select v-model="user_data.education" :items="education_options" label="höchste abgeschlossene Ausbildung">
            </v-select>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="showSaveBtn" class="mx-0 d-flex" style="min-height: 40px;" >
      <v-btn v-if="changed" dark @click="save" class="mx-auto mb-5">Speichern</v-btn>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import Header1 from "@/components/Header1";

const CONTEXT = "@user_profile";

export default {
  name: 'UserData',
  components: { Header1 },
  props: ['show_save_btn'],
  data: () => ({
    loading:false,
    error:false,
    reason:false,
    changed:false,
    user_data_orig: {},
    showSaveBtn:true,
    user_data: {
      username: undefined,
      sex: undefined,
      birthyear: undefined,
      country: undefined,
      which_country: undefined,
      zip: undefined,
      family: undefined,
      num_kids: 0,
      kids: [],
      job: undefined,
      workhours: 0,
      education: undefined,
    },
    nkids: 0,
    kids:{ kid0:undefined, kid1:undefined,kid2:undefined,kid3:undefined,kid4:undefined,kid5:undefined,kid6:undefined,kid7:undefined,kid8:undefined,kid9:undefined,},
    sex_options: ['männlich', 'weiblich'],
    country_options: ['Deutschland', 'Österreich', 'Schweiz', 'Lichtenstein', 'Italien', 'Anderes Land'],
    family_options: ['Single', 'In Beziehung',],
    job_options: ['Angestellter', 'Selbständig',],
    education_options: ['Pflichtschule', 'Lehre', 'Matura/Abitur', 'Universität/Fachhochschule'],
    year_options: [],
  }),
  mounted() {
    if (this.show_save_btn===false)
      this.showSaveBtn=false;
    // fill year_options with past 100 years (allowing 16 .. 100 year olds)
    var start = new Date().getFullYear() - 101;
    for (var i = (100 - 15); i > 0; i--)
      this.year_options.push(start + i);
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      var data=await this.$backend.get_settings(CONTEXT, {onError: this.onLoadError});
      this.loading = false;
      if (data) {
        data.kids ||= []; // make sure it is an array
        this.user_data_orig = data;
        this.user_data = JSON.parse(JSON.stringify(data));
        (this.user_data_orig.kids || []).forEach((year, i) => {
          this.kids['kid' + i] = year;
        })
        // after loading must assign nkids from user_data!!!
        this.nkids = this.user_data.num_kids;
        this.user_data.username ||= this.$app.user.name;
      }
    },
    onLoadError(reason) {
      this.loading = false;
      this.user_data = {};
      this.error = true;
      this.reason = reason;
    },
    async save() {
      this.loading = true;
      await this.$backend.set_settings(CONTEXT, this.user_data, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError,
        no_notify:true,
      });
      this.load();
    },
    canContinue() {
      if (!this.user_data.username) {
        this.$events.$emit("error", "Der Benutzername wird benötigt, muss aber nicht dein wirklicher Name sein.")
        return false;
      }
      return true;
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.user_data_orig = data;
      this.user_data = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
  },
  computed: {},
  watch: {
    nkids(n, o) {
      this.user_data.num_kids = n;
    },
    kids: {
      deep: true,
      handler(n, o) {
        var kids = []
        for(var i=0; i<this.nkids; i++){
          var year=this.kids['kid'+i]||"";
          kids.push(year);
        }
        this.user_data.kids=kids;
      }
    },
    user_data: {
      deep: true,
      handler() {
        this.changed = JSON.stringify(this.user_data_orig) !== JSON.stringify(this.user_data);
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>